import { createFileRoute } from '@tanstack/react-router'
import { trpc } from '@/main'
import { useOffer } from '@/hooks/use-offer'
import { DistributionPending } from './-components/shared/distribution-pending'
import { Distribution } from './-components/shared/distribution'
import { EmptyState } from './-components/shared/empty-state'
import { GroupContextProvider } from './-components/shared/group-context'

export const Route = createFileRoute('/_app/offers/$offerId/distribution')({
  loaderDeps: ({ search }) => ({ type: search.type }),
  loader: ({ context, deps, params }) => {
    context.queryClient.prefetchQuery(
      trpc.companies.getOfferApplicantIndicators.queryOptions({ offerId: Number(params.offerId), type: deps.type }),
    )
  },
  component: RouteComponent,
  pendingComponent: DistributionPending,
})

function RouteComponent() {
  const { offerId } = Route.useParams()
  const { offerApplicants } = useOffer(Number(offerId))

  const members = (offerApplicants?.members ?? []).map((member) => ({
    ...member,
    id: member.id,
  }))

  if (offerApplicants?.emptyStateCode) {
    return <EmptyState code={offerApplicants.emptyStateCode} surface="distribution" />
  }

  return (
    <GroupContextProvider type="offer">
      <Distribution profiles={members} data={offerApplicants?.distribution} showFilters />
    </GroupContextProvider>
  )
}
